import { browser } from '$app/environment';
import { TAILWIND_BREAKPOINT } from '$lib/statics';

let isMd = $state<boolean>(false);
let isLg = $state<boolean>(false);
let isXl = $state<boolean>(false);

if (browser) {
    const mdQuery = window.matchMedia(`(min-width: ${TAILWIND_BREAKPOINT.md.minWidth}px)`);
    const lgQuery = window.matchMedia(`(min-width: ${TAILWIND_BREAKPOINT.lg.minWidth}px)`);
    const xlQuery = window.matchMedia(`(min-width: ${TAILWIND_BREAKPOINT.xl?.minWidth ?? 1280}px)`);

    isMd = mdQuery.matches;
    isLg = lgQuery.matches;
    isXl = xlQuery.matches;

    mdQuery.addEventListener('change', (e) => (isMd = e.matches));
    lgQuery.addEventListener('change', (e) => (isLg = e.matches));
    xlQuery.addEventListener('change', (e) => (isXl = e.matches));
}

export const deviceScreen = {
    /* ----------------------------------------------------
     * 1. EXACT DEVICES (Mutually Exclusive)
     * ---------------------------------------------------- */
    /** Phones only (< 768px) */
    get isMobile() {
        return !isMd;
    },

    /** Tablets only, like iPad portrait (768px – 1023px) */
    get isTablet() {
        return isMd && !isLg;
    },

    /** Desktops and Laptops only (>= 1024px) */
    get isDesktop() {
        return isLg;
    },

    /* ----------------------------------------------------
     * 2. RANGE HELPERS (Spelled out — no negation needed!)
     * ---------------------------------------------------- */
    /**
     * Phones & Tablets (< 1024px)
     * Perfect for touch drawers, bottom sheets, mobile back buttons.
     */
    get smallerThanDesktop() {
        return !isLg; // Mobile + Tablet
    },

    /**
     * Tablets & Desktops (>= 768px)
     * Perfect for multi-column grids, sidebar layouts.
     */
    get biggerThanMobile() {
        return isMd; // Tablet + Desktop
    },

    /* ----------------------------------------------------
     * 3. TAILWIND BREAKPOINT HELPERS (>= breakpoint)
     * ---------------------------------------------------- */
    get isMd() {
        return isMd;
    },
    get isLg() {
        return isLg;
    },
    get isXl() {
        return isXl;
    }
};